import type { Inventory, ProductVariantInventory } from '@libs/algolia';

export const emptyInventory = (id: string): Inventory =>
    ({
        id,
        ats: 0,
        orderable: true,
    }) as Inventory;

export const getSelectedInventory = ({
    inventories,
    productId,
    deliveryType,
}: {
    productId: string;
    deliveryType: string;
    inventories?: ProductVariantInventory;
}) => {
    const inventoryKey = `${productId}-${deliveryType}`;
    const selectedInventory = inventories?.[inventoryKey];

    return selectedInventory || emptyInventory(inventoryKey);
};
